<template lang="pug">
div(:data-tg-tour="tgAddAsset.tour"
  :data-tg-group="tgAddAsset.group"
  ).wrap-item-object-manager.f
  div(v-if="assetType").wrap-assets
    div.sub-header.f.fm.flex-between.px4
      v-icon(@click="assetType = null" size="20px" dark) mdi-chevron-left
      v-icon(size="20px" dark).mr2 {{assetType.icon}}
    div.assets.overflow-scroll
      div(@click="showNewAsset = !showNewAsset").asset-preview.f.fh.cursor-pointer
        v-icon(dark) mdi-plus
      div(:data-tg-tour="tgCreateObject.tour"
        :data-tg-group="tgCreateObject.group")
        Draggable(v-model="showingAssets")
          AtomAssetItem(v-for="asset in showingAssets"
            :asset="asset" :key="asset.id"
            :type="assetType.type"
            :assetLoadingProgresses="assetLoadingProgresses"
            @updateAssetOrder="updateAssetOrder" @dropObject="dropObject")
  div(v-else).wrap-object-types
    div(v-for="item in assetTypes"
      @click="assetType = item"
      @mouseover="hoveredIconType = item.type"
      @mouseleave="hoveredIconType = null"
      ).asset-type-icon.relative.f.fh.w36.h36.mb10.rounded.cursor-pointer
      v-icon(size="22px" dark) {{item.icon}}
      div(:class="{'active': hoveredIconType == item.type}"
        ).wrap-info.absolute.h-full.px10.py4.f.fm.rounded
        span.fz14 {{item.name}}
      div(v-if="getImportedAssetNum(item.type) != 0"
        ).wrap-imported-assets-num.absolute.w15.h15.f.fh
        span.fz10.bold {{getImportedAssetNum(item.type)}}
  ModalWindow(:showModal="showNewAsset" @closeModalWindow="showNewAsset = false")
    ModuleNewAsset(:assetType="assetType" :tutorial="tutorial"
      @completeSaveAsset="showNewAsset = false"
      @closeModalWindow="showNewAsset = false"
      @startTutorialToCreateObject="startTutorialToCreateObject"
      @click.stop)
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
$top_margin_size: 64px; // 56px; // calc(32px + 12px + 12px);
$assets_window_width: 80px;
$assets_window_max_height: calc(98vh - #{$top_margin_size});
$assets_window_padding_size: 6px;
.wrap-item-object-manager {
  position: absolute;
  top: $top_margin_size;
  left: 12px;
  .wrap-assets {
    width: $assets_window_width;
    max-height: $assets_window_max_height;
    background: $primary_bg_color;
    border-radius: 3px;
    box-shadow: $box_shadow;
    .sub-header {
      width: 100%;
      height: 28px;
      background: $dark_primary_bg_color;
      border-radius: 3px;
      span {
        color: $dark_primary_text_color;
      }
    }
    .assets {
      padding: $assets_window_padding_size;
      max-height: 80vh;
      .asset-preview {
        // position: relative;
        width: calc(#{$assets_window_width} - #{$assets_window_padding_size} * 2);
        height: calc(#{$assets_window_width} - #{$assets_window_padding_size} * 2);
        border-radius: 3px;
        background: $secondary_bg_color;
      }
    }
  }
  .wrap-object-types {
    border-radius: 3px;
    .asset-type-icon.relative {
      background: $active_color;
      box-shadow: $box_shadow;
      .wrap-info {
        display: none;
        top: 0; left: calc(100% + 6px);
        background: $overlay_color;
        span {
          word-break: keep-all;
          color: $dark_primary_text_color;
        }
        &.active {
          display: flex;
        }
      }
      .wrap-imported-assets-num {
        right: -6px; top: -6px;
        border-radius: 50%;
        border: solid 1px $active_color;
        background: $primary_bg_color;
        span {
          color: $active_color;
          // color: $dark_primary_text_color;
        }
      }
    }
  }
}
</style>

<script>
import '@sjmc11/tourguidejs/src/scss/tour.scss'
import { TourGuideClient } from '@sjmc11/tourguidejs'
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import Draggable from 'vuedraggable'
import ModalWindow from '@/components/shared/ModalWindow'
import ModuleNewAsset from '@/components/module/studio/ModuleNewAsset'
import AtomNewAsset from '@/components/atom/studio/AtomNewAsset'
import AtomAssetItem from '@/components/atom/studio/AtomAssetItem'

export default {
  components: {
    Draggable,
    ModalWindow,
    ModuleNewAsset,
    AtomNewAsset,
    AtomAssetItem
  },
  props: {
    assets: { type: Array, required: true },
    frame: { type: Object, required: true },
    assetLoadingProgresses: { type: Array, required: true },
    tutorial: { type: Object, default: null }
  },
  watch: {
    assets: {
      handler () {
        if (this.preventUpdateByWatch) {
          this.preventUpdateByWatch = false
          return
        }
        this.updateShowingAsset()
      },
      deep: true
    },
    assetType () {
      this.updateShowingAsset()
    }
  },
  data () {
    return {
      showingAssets: [],
      assetType: null,
      // assetType: { type: 'actor', name: 'キャラクター', icon: 'mdi-human' },
      // assetType: { type: 'onomatopoeia', name: '背景画', icon: 'mdi-image' },
      // assetType: { type: '3d_object', name: '3Dオブジェ', icon: 'mdi-cube-outline' },
      // showNewAsset: true,
      showNewAsset: false,
      actorAssets: [], backgroundAssets: [], objectAssets: [],
      threeDStageAssets: [], threeDObjectAssets: [],
      imageObjectAssets: [], onomatopoeiaAssets: [], manpuAssets: [],
      effectBackgroundAssets: [], streetViewAssets: [],
      preventUpdateByWatch: true,
      
      hoveredIconType: null,

      tgAddAsset: {
        tour: [
          '<p>Comicaroidでは様々な種類のアセットを組み合わせてコマのイラストを生成していきます。ますは好きなアセットをインポートしてみましょう！</p>',
        ].join(''),
        group: 'add_asset_in_studio'
      },
      tgCreateObject: {
        tour: [
          '<p class="mb20">アセットを好きな位置にドラッグしてオブジェクトを作成してみましょう！</p>',
          // '<iframe style="border-radius: 3px;" height="201" src="https://www.youtube.com/embed/uTcYBCF6KxU?loop=1&playlist=uTcYBCF6KxU&autoplay=1&mute=1&showinfo=0&rel=0&modestbranding=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>'
          '<video loop muted autoplay playsinline controls class="w-full">'
            + '<source src="/tutorial/create_object_in_studio.mp4" type="video/mp4">'
            + '</video>'
        ].join(''),
        group: 'create_object_in_studio'
      }
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  async created () {
    this.updateShowingAsset()
    this.preventUpdateByWatch = false
  },
  async mounted () {
    this.startTutorialToAddAsset()
  },
  methods: {
    updateShowingAsset () {
      this.actorAssets = this.assets.filter(a => a.type === 'actor')
      // this.objectAssets = this.assets.filter(a => a.type === 'object')
      this.backgroundAssets = this.assets.filter(a => a.type === 'background')
      this.effectBackgroundAssets = this.assets.filter(a => a.type === 'effect_background')
      this.threeDStageAssets = this.assets.filter(a => a.type === '3d_stage')
      this.threeDObjectAssets = this.assets.filter(a => a.type === '3d_object')
      this.imageObjectAssets = this.assets.filter(a => a.type === 'image_object')
      this.onomatopoeiaAssets = this.assets.filter(a => a.type === 'onomatopoeia')
      this.manpuAssets = this.assets.filter(a => a.type === 'manpu')
      this.streetViewAssets = this.assets.filter(a => a.type === 'street_view')
      
      if (!this.assetType) return
      switch (this.assetType.type) {
        case 'actor':
          this.showingAssets = this.actorAssets
          break
        case 'background':
          this.showingAssets = this.backgroundAssets
          break
        case 'effect_background':
          this.showingAssets = this.effectBackgroundAssets
          break
        // case 'object':
        //   this.showingAssets = this.objectAssets
        //   break
        case '3d_stage':
          this.showingAssets = this.threeDStageAssets
          break
        case '3d_object':
          this.showingAssets = this.threeDObjectAssets
          break
        case 'image_object':
          this.showingAssets = this.imageObjectAssets
          break
        case 'onomatopoeia':
          this.showingAssets = this.onomatopoeiaAssets
          break
        case 'manpu':
          this.showingAssets = this.manpuAssets
          break 
        case 'street_view':
          this.showingAssets = this.streetViewAssets
          break
      }
      // console.log('updateShowingAsset:', this.showingAssets)
    },
    updateAssetOrder () {
      let assetOrder = this.frame.assetOrder
      assetOrder[this.assetType.type] = this.showingAssets.map(a => a.id)
      const rp = this.$route.params
      database.frameCollection(rp.comicId, rp.episodeId, rp.pageId)
        .update(rp.frameId, { assetOrder })
    },
    async dropObject ({ asset, dropPosition }) {
      await this.$emit('dropObject', { asset, dropPosition })
    },
    getImportedAssetNum (type) {
      return this.assets.filter(a => a.type === type).length
    },
    async startTutorialToAddAsset () {
      if (!this.tutorial
      || (this.tutorial && !this.tutorial.body[this.tgAddAsset.group])) {
        await this.sleep(400)
        const tg = new TourGuideClient({
          finishLabel: 'OK',
          hidePrev: true, showStepDots: false, showStepProgress: false,
          targetPadding: 10
        })
        tg.onFinish(() => {
          // この処理入れないともう一度チュートリアルを表示できない
          const tgDialog = document.getElementsByClassName('tg-dialog')[0]
          if (tgDialog) tgDialog.remove()
        })
        tg.start(this.tgAddAsset.group)

        this.updateTutorialAfterFinish({ tgGroupName: this.tgAddAsset.group })

        // let tutorialObj
        // if (this.tutorial) {
        //   this.tutorial.body[this.tgAddAsset.group] = true
        //   tutorialObj = this.tutorial
        // } else {
        //   tutorialObj = {
        //     body: { [this.tgAddAsset.group]: true },
        //     createdAt: new Date(), createdBy: this.uid
        //   }
        // }
        // database.userTutorialCollection(this.uid).set('studio', tutorialObj)
      }
    },
    async startTutorialToCreateObject () {
      if (!this.tutorial
      || (this.tutorial && !this.tutorial.body[this.tgCreateObject.group])) {
        const tg = new TourGuideClient({
          finishLabel: 'OK',
          hidePrev: true, showStepDots: false, showStepProgress: false,
          targetPadding: 10
        })
        tg.onFinish(() => {
          // この処理入れないともう一度チュートリアルを表示できない
          const tgDialog = document.getElementsByClassName('tg-dialog')[0]
          if (tgDialog) tgDialog.remove()
        })
        await this.sleep(400)
        tg.start(this.tgCreateObject.group)

        this.updateTutorialAfterFinish({ tgGroupName: this.tgCreateObject.group })
      }
    },
    updateTutorialAfterFinish ({ tgGroupName }) {
      let tutorialObj
      if (this.tutorial) {
        this.tutorial.body[tgGroupName] = true
        tutorialObj = this.tutorial
      } else {
        tutorialObj = {
          body: { [tgGroupName]: true },
          createdAt: new Date(), createdBy: this.uid
        }
      }
      database.userTutorialCollection(this.uid).set('studio', tutorialObj)
    }
  }
}
</script>
